'use strict';

window.onload = function(){
	let faqQuestions = [...document.querySelectorAll('.faq__question')]
	faqQuestions.map(question => {
		question.querySelector('.faq__question-header').addEventListener('click', e => {
			let svgIcon = e.target.closest('.faq__question').querySelector('.faq__question-icon')
			svgIcon.classList.toggle('active')
			let body = e.target.closest('.faq__question').querySelector('.faq__question-body')
			body.classList.toggle('active')
		})
	})
	var slider1 = document.getElementById('slider-round_1');
	var slider2 = document.getElementById('slider-round_2');
	noUiSlider.create(slider1, {
		start: [3000],
		connect: 'lower',
		range: {
			'min': 3000,
			'max': 1250000
		},
		format: wNumb({
			decimals: 0,
		})
	});
	noUiSlider.create(slider2, {
		start: [1],
		connect: 'lower',
		range: {
			'min': 1,
			'max': 75
		},
		step: 1,
		format: wNumb({
			decimals: 0,
		})

	});
	let  sliderValueInput1 = document.getElementById('sliderValue_1')
	let  sliderValueInput2 = document.getElementById('sliderValue_2')
	let firstValue = document.getElementById('firstValue')
	let secondValue = document.getElementById('secondValue')
	let thirdValue = document.getElementById('thirdValue')
	let fourthValue = document.getElementById('fourthValue')
	let fifthValue = document.getElementById('fifthValue')
	let bet;
	let days = 16;
	slider1.noUiSlider.on('update', () => {
		sliderValueInput1.value = new Intl.NumberFormat('ru-RU').format(slider1.noUiSlider.get()) + ' ₽'
		bet = slider1.noUiSlider.get();
		days = slider2.noUiSlider.get();
		let bet1;
		let bet2;
		let bet3 = bet * 2;
		let bet4 = bet * 0.0089
		let bet5 = bet * 0.0089 / 30
		if (bet <= 2999) {
			bet1 = 0
			bet2 = 0
			bet3 = 0
			bet4 = 0
			bet5 = 0
		} else if (+days < 16){
			bet1 = 0;
			if (bet >= 149253) {
				bet2 = 2000 * days
				if (bet2 >= 42000 ) {
					bet2 = 42000
				}
			} else {
				bet2 =  (bet * 0.0134) * days;
				if (bet2 >= 42000 ) {
					bet2 = 42000
				}
			}
		} else {
			if (bet >= 149253) {
				bet1 = 2000 * days;
				if (bet1 >= 42000 ) {
					bet2 = 42000
				} else {
					bet2 = bet1
				}
			} else {
				bet1 = (bet * 0.0134) * days;
				if (bet1 >= 42000 ) {
					bet2 = 42000
				} else {
					bet2 = bet1
				}
			}
		}

		firstValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet1.toFixed(0));
		secondValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet2.toFixed(0));
		thirdValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet3.toFixed(0));
		fourthValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet4.toFixed(0));
		fifthValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet5.toFixed(0));
	});

	sliderValueInput1.addEventListener('change', e => {
		let value = e.target.value.replace(/[^0-9,.]/g, ' ');
		slider1.noUiSlider.set(+value);
		e.target.value = new Intl.NumberFormat('ru-RU').format(value) + ' ₽';
		bet = value;
		days = slider2.noUiSlider.get();
		let bet1;
		let bet2;
		let bet3 = bet * 2;
		let bet4 = bet * 0.0089
		let bet5 = bet * 0.0089 / 30
		if (bet <= 2999) {
			bet1 = 0
			bet2 = 0
			bet3 = 0
			bet4 = 0
			bet5 = 0
		} else {
			if (+days < 16){
				bet1 = 0;
				if (bet >= 149253) {
					bet2 = 2000 * days
					if (bet2 >= 42000 ) {
						bet2 = 42000
					}
				} else {
					bet2 =  (bet * 0.0134) * days;
					if (bet2 >= 42000 ) {
						bet2 = 42000
					}
				}
			} else {
				if (bet >= 149253) {
					bet1 = 2000 * days;
					if (bet1 >= 42000 ) {
						bet2 = 42000
					} else {
						bet2 = bet1
					}
				} else {
					bet1 = (bet * 0.0134) * days;
					if (bet1 >= 42000 ) {
						bet2 = 42000
					} else {
						bet2 = bet1
					}
				}
			}

		}

		firstValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet1.toFixed(0));
		secondValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet2.toFixed(0));
		thirdValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet3.toFixed(0));
		fourthValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet4.toFixed(0));
		fifthValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet5.toFixed(0));
	})
	slider2.noUiSlider.on('update', () => {
		sliderValueInput2.value = formatDays(new Intl.NumberFormat('ru-RU').format(slider2.noUiSlider.get()));
		days = slider2.noUiSlider.get();
		bet = sliderValueInput1.value.match(/\d+/g).join('');
		bet = parseInt(bet, 10);
		let bet1;
		let bet2;
		let bet3 = bet * 2;
		let bet4 = bet * 0.0089
		let bet5 = bet * 0.0089 / 30
		if (bet <= 2999) {
			bet1 = 0
			bet2 = 0
			bet3 = 0
			bet4 = 0
			bet5 = 0
		} else {
			if (bet >= 149253) {
				bet2 = 2000 * days
				if (bet2 >= 42000 ) {
					bet2 = 42000
				}
			} else {
				bet2 = (bet * 0.0134) * days
				if (bet2 >= 42000 ) {
					bet2 = 42000
				}
			}
			if (+days < 16){
				bet1 = 0;
			} else {
				if (bet >= 149253) {
					bet1 = 2000 * days;
				} else {
					bet1 = (bet * 0.0134) * days;
				}
			}
		}

		firstValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet1.toFixed(0));
		secondValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet2.toFixed(0));
		thirdValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet3.toFixed(0));
		fourthValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet4.toFixed(0));
		fifthValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet5.toFixed(0));
	});
	sliderValueInput2.addEventListener('change', e => {
		let value = e.target.value.replace(/[^0-9,.]/g, ' ');
		slider2.noUiSlider.set(+value);
		e.target.value = formatDays(new Intl.NumberFormat('ru-RU').format(value))
		days = value
		bet = sliderValueInput1.value.match(/\d+/g).join('');
		bet = parseInt(bet, 10);
		let bet1;
		let bet2;
		let bet3 = bet * 2;
		let bet4 = bet * 0.0089
		let bet5 = bet * 0.0089 / 30
		if (bet <= 2999) {
			bet1 = 0
			bet2 = 0
			bet3 = 0
			bet4 = 0
			bet5 = 0
		} else {
			if (bet >= 149253) {
				bet2 = 2000 * days
				if (bet2 >= 42000 ) {
					bet2 = 42000
				}
			} else {
				bet2 = (bet * 0.0134) * days
				if (bet2 >= 42000 ) {
					bet2 = 42000
				}
			}
			if (+days < 16){
				bet1 = 0;
			} else {
				if (bet >= 149253) {
					bet1 = 2000 * days;
				} else {
					bet1 = (bet * 0.0134) * days;
				}
			}
		}

		firstValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet1.toFixed(0));
		secondValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet2.toFixed(0));
		thirdValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet3.toFixed(0));
		fourthValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet4.toFixed(0));
		fifthValue.querySelector('span').textContent = new Intl.NumberFormat('ru-RU').format(bet5.toFixed(0));
	})

	function formatDays(numDays) {
		if (numDays === 1) {
			return numDays + ' день';
		} else if (numDays >= 2 && numDays <= 4) {
			return numDays + ' дня';
		} else if (numDays >= 5 && numDays <= 20) {
			return numDays + ' дней';
		} else {
			const lastDigit = numDays % 10;
			if (lastDigit === 1) {
				return numDays + ' день';
			} else if (lastDigit >= 2 && lastDigit <= 4) {
				return numDays + ' дня';
			} else {
				return numDays + ' дней';
			}
		}
	}

}

//# sourceMappingURL=main.js.map

//# sourceMappingURL=main.js.map
